import ApiClient from '@/api/ApiClient';

import type {
  Form,
} from '../models';

export class FormClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getForms(): Promise<Form[]> {
    return this.apiClient.get({
      path: '/api/forms',
    });
  }

  syncForms(request: { body?: string; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.put({
      path: '/api/forms',
      body,
    });
  }

  createForm(request: { body?: string; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/forms',
      body,
    });
  }

  getForm(request: { formId: string; }): Promise<Form> {
    const { formId } = request;
    return this.apiClient.get({
      path: `/api/forms/${formId}`,
    });
  }

  updateForm(request: { formId: string; body?: string; }): Promise<void> {
    const { formId, body } = request;
    return this.apiClient.put({
      path: `/api/forms/${formId}`,
      body,
    });
  }

  deleteForm(request: { formId: string; }): Promise<void> {
    const { formId } = request;
    return this.apiClient.del({
      path: `/api/forms/${formId}`,
    });
  }
}

export default FormClient;
